import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Stack } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import CustomTypography from '@/components/dataDisplay/CustomTypography'
import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { AggregatedPowerMeasurementView } from '@/features/site/components/power_measurements/AggregatedPowerMeasurementView'
import GreyAndWhiteCloud from '@/features/site/components/power_measurements/GreyAndWhiteCloud'
import WhiteCloud from '@/features/site/components/power_measurements/WhiteCloud'
import { useSiteQuery } from '@/features/site/hooks/useSiteQuery'

export const PowerMeasurements = () => {
  const { t } = useTranslation()
  const { loggedInUser } = useAuth()
  const siteUuid = loggedInUser?.allowedRoIds?.[0] ?? ''

  const { site, isFetching: isFetchingSite } = useSiteQuery(
    { uuid: siteUuid },
    {
      enabled: Boolean(siteUuid),
    },
  )

  if (!site || isFetchingSite) return null

  return (
    <Stack
      alignItems="center"
      direction="column"
      justifyContent="center"
      sx={{ width: '100%', height: '100%' }} // Add this line
    >
      <WhiteCloud style={{ position: 'absolute', top: 150, left: 500, zIndex: -99 }} />
      <GreyAndWhiteCloud style={{ position: 'absolute', top: 400, right: 200, zIndex: -99 }} />
      <CustomTypography fontSize={36} variant="h1">
        {t('customer_measurements.power_measurements.title')}
      </CustomTypography>
      <AggregatedPowerMeasurementView location={site.location!} siteUuid={site.uuid!} />
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <InfoOutlinedIcon color={'info'} width={'20px'} />
        <CustomTypography variant="body1">{t('customer_measurements.power_measurements.information')}</CustomTypography>
      </Stack>
    </Stack>
  )
}
